import type { TemplateOnlyComponent } from '@ember/component/template-only';
import { LinkTo } from '@ember/routing';

import { IfCoach } from '../user/rights/if-coach.gts';
import { IfCoachee } from '../user/rights/if-coachee.gts';

interface HeaderSignature {
  Element: HTMLElement;
}

const Header: TemplateOnlyComponent<HeaderSignature> = <template>
  <div class="navbar navbar-expand bg-white shadow-sm py-2" ...attributes>
    <div class="container-fluid">
      <LinkTo class="navbar-brand fw-bold ms-2" @route="index">Xceed</LinkTo>

      <ul class="navbar-nav flex-row gap-3 me-auto">
        <IfCoach>
          <:isCoach>
            <li class="nav-item">
              <LinkTo
                class="nav-link fw-bold"
                @route="coaching.coach"
              >Coach</LinkTo>
            </li>
          </:isCoach>
        </IfCoach>
        <IfCoachee>
          <:isCoachee>
            <li class="nav-item">
              <LinkTo
                class="nav-link fw-bold"
                @route="coaching.coachee"
              >Coachee</LinkTo>
            </li>
          </:isCoachee>
        </IfCoachee>
      </ul>

      <div
        class="d-flex align-items-center gap-3 gap-lg-4 ms-auto flex-shrink-0"
      >
        <button
          type="button"
          class="btn btn-link link-primary p-1 d-lg-none d-inline-flex align-items-center justify-content-center border-0"
          aria-label="Open menu"
          data-bs-toggle="offcanvas"
          data-bs-target="#sidebarMobileMenu"
        >
          <iconify-icon inline icon="ph:list" class="fs-4" aria-hidden="true" />
        </button>
      </div>
    </div>
  </div>
</template>;

export default Header;
